const ssrReplaceAll = (string, from, to) => {
  let text = string || "";
  const countWord = (text || "").split(from).length;
  for (let i = 0; i < countWord; i++) {
    text = (text || "").replace(from, to);
  }

  return text
}
export default ssrReplaceAll
